import SlideElektrowerkzeuge from "./SlideElektrowerkzeuge";

export default function Elektrowerkzeuge() {
  return [<SlideElektrowerkzeuge key="elektrowerkzeuge" />];
}
